// Centralise tes imports (simple, explicite, fiable)
import fr1 from "./posts/fr/2026-05-10-pourquoi-ta-vie-est-mal-organisee.json";
import fr2 from "./posts/fr/2026-05-11-vie-systeme-exploitation.json";
import fr3 from "./posts/fr/2026-06-16-gerer-operations-financieres-life.json";
// import en1 from "./posts/en/2026-02-01-life-cockpit.json";

const allPosts = [
  fr1,
  fr2,
  fr3,
  // en1,
];

function normalizeLang(lang) {
  return lang?.split("-")[0];
}

export function getPosts({ lang }) {
  const normalizedLang = normalizeLang(lang);

  return allPosts
    .filter(p => !normalizedLang || p.lang === normalizedLang)
    .sort((a, b) => new Date(b.date) - new Date(a.date));
}

export function getPostBySlug({ slug, lang }) {
  const normalizedLang = normalizeLang(lang);

  return allPosts.find(p => p.slug === slug && (!normalizedLang || p.lang === normalizedLang));
}
